export default __webpack_public_path__ + "static/media/non-referable-icon.3ff3b14b.svg";